import { APIError } from '../errors/APIError';
import { useAPIQuery } from '../useAPIProvider';

export const useIntercomHash = () => {
  return useAPIQuery(['getIntercomHash'], async client => {
    const response = await client.intercom.getHash();

    if (response.status !== 200) throw APIError.fromResponse(response);

    return response.body;
  });
};
